import { render, staticRenderFns } from "./AssessmentTasksTable.vue?vue&type=template&id=4dbaca66&scoped=true&"
import script from "./AssessmentTasksTable.vue?vue&type=script&lang=js&"
export * from "./AssessmentTasksTable.vue?vue&type=script&lang=js&"
import style0 from "./AssessmentTasksTable.vue?vue&type=style&index=0&id=4dbaca66&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dbaca66",
  null
  
)

export default component.exports